var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDebugging = function SvgDebugging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#debugging_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 75.5c20.71 0 37.5-16.79 37.5-37.5S60.71.5 40 .5 2.5 17.29 2.5 38 19.29 75.5 40 75.5M40 63c13.807 0 25-11.193 25-25S53.807 13 40 13 15 24.193 15 38s11.193 25 25 25",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.19 80.5H19.387c-3.914 0-6.31-4.293-4.256-7.624l21.402-34.707c1.953-3.167 6.558-3.167 8.512 0l21.401 34.707c2.054 3.33-.342 7.624-4.256 7.624"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "debugging_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h80v80H0z"
  })))));
};
export default SvgDebugging;